import { DocumentContentRouter } from "../../routers/DocumentContentRouter"
import { DocumentMapRouter } from "../../routers/DocumentMapRouter"
import { SidebarRouter } from "../../routers/SidebarRouter"

import * as Styled from "./DocumentDesktopLayout.styled"

export const DocumentDesktopLayout = () => {
    return (
        <Styled.Wrapper>
            <SidebarRouter />
            <DocumentContentRouter />
            <Styled.Map>
                <DocumentMapRouter />
            </Styled.Map>
        </Styled.Wrapper>
    )
}